import React, { useContext } from 'react';
import './SpecialOfferBanner.css';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../context/LanguageContext';

const SpecialOfferBanner = () => {
  const { t, language } = useContext(LanguageContext);

  const handleClaimOffer = () => {
    console.log('Claim offer clicked');
    // Aquí iría la lógica para reclamar la oferta
  };

  return (
    <section className="special-offer-section">
      <div className="offer-banner">
        <div className="offer-content">
          <h2 className="offer-title">{t("specialOffer", "title")}</h2>
          <p className="offer-description">
            {t("specialOffer", "description")}
          </p>
        </div>
        <Link to={`/${language.value}/booking`} className='offer-button-link' >
          <button
            className="offer-button"
            onClick={handleClaimOffer}
          >
            <span>{t("specialOffer", "claimOffer")}</span>
          </button>
        </Link>
      </div>
    </section>
  );
};

export default SpecialOfferBanner;